<template lang="html">
  <section class="ctn-operation-form take-place">
  	<div class="white-box row title">
  		<router-link :to="{ name: 'TransactionsTable' }" class="ctn-icon">
  			<span class="icon-arrow-back"></span>
  		</router-link>
		<div class="label" v-if="missionExist">
			{{ name }}
		</div>
		<div class="label" v-else>
			Nouvelle opération
		</div>
  	</div>
	<div class="white-box">
		<edit-main></edit-main>
      	<div class="take-place" v-if="missionExist">
			<div class="separator"></div>
			<edit-docs :operation="operation" @needToUpdate="checkForOperation"></edit-docs>
  			<edit-contracts-and-supports></edit-contracts-and-supports>
		</div>
	</div>
  </section>
</template>

<script>
import EditMain from './EditForm/Main'
import EditDocs from './EditForm/Docs'
import EditContractsAndSupports from './EditForm/ContractsAndSupports'

export default {
	components: {
		EditMain,
		EditDocs,
		EditContractsAndSupports
	},
	data () {
		return {
			name: null,
			missionExist: false,
			operation: null
		}
	},
	mounted () {
		this.checkForOperation()
	},
	methods: {
		checkForOperation () {
			if (this.$route.name === 'MyTransactionsEdit') {
				this.$store.dispatch('getOperation', this.$route.params.id).then((result) => {
					this.operation = this.$store.getters.operation(this.$route.params.id)
					this.name = this.operation.title
					this.missionExist = true
				}).catch((error) => {
					console.log(error)
				})
			}
		}
	},
	watch: {
		$route (to, from) {
			this.checkForOperation()
		}
	}
}
</script>


// WEBPACK FOOTER //
// Edit.vue?36fb4cde